import React from 'react'

const AboutLanding = () => {
  return (
    <div className='about_landing'>
       <h1 className='title'>About</h1>
    </div>
  )
}

export default AboutLanding